/*
 * Load-more for the collection product grid.
 * Click a button to fetch the next paginated page, append its product cards to
 * the existing #product-grid, and advance/remove the button. Uses document-level
 * event delegation so it keeps working after Dawn's facet AJAX replaces the grid.
 * paginate.next.url already carries active filter/sort params, so they are preserved.
 */
(function () {
  function init() {
    if (window.__loadMoreInit) return;
    window.__loadMoreInit = true;
    document.addEventListener('click', onClick);
  }

  async function onClick(event) {
    var btn = event.target.closest('[data-load-more]');
    if (!btn) return;
    event.preventDefault();

    var url = btn.getAttribute('href');
    if (!url || btn.getAttribute('aria-busy') === 'true') return;

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');

    try {
      var res = await fetch(url);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var newGrid = doc.getElementById('product-grid');
      var curGrid = document.getElementById('product-grid');
      if (newGrid && curGrid) {
        var items = newGrid.querySelectorAll('.grid__item');
        items.forEach(function (li) {
          curGrid.appendChild(document.importNode(li, true));
        });
      }

      var nextBtn = doc.querySelector('[data-load-more]');
      if (nextBtn && nextBtn.getAttribute('href')) {
        btn.setAttribute('href', nextBtn.getAttribute('href'));
      } else {
        var wrap = btn.closest('[data-load-more-wrap]') || btn;
        wrap.remove();
      }
    } catch (err) {
      // Fallback: navigate to the next page like a normal link.
      window.location.href = url;
    } finally {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('loading');
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
